class NmbrPageState {
}

export default NmbrPageState;
